// =============================================================================
//  Copyright : 2025 semantics GmbH
//  Date      : $Date: 2026-06-26 22:40:15 +0200 (Fri, 26 Jun 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: s.bock $
//  Revision  : $Rev: 164054 $
//  Purpose   : parts for scidesk support
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import log from 'uix/logging';
import { loadLazy as ll } from 'uix/parts';
export const AutoStruct = ll(()=>import(/* webpackChunkName: 'scidesk' */ './autostruct'));
export const GraphicBoxes = ll(()=>import(/* webpackChunkName: 'scidesk' */ './gboxes'));
export const NewspaperPageSample = ll(()=>import(/* webpackChunkName: 'scidesk' */ './newspaper_sample'));
export const ScideskStart = ({})=>{
    return 'XXXX';
};
